import { fetchFacilitiesList } from '../facilities';

export const accessCheck = () => fetchFacilitiesList();
